
import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import PanelFrame from '@/components/molecules/PanelFrame.vue'

/**
 * 生徒毎学習進捗ページパネルレイアウト
 */
@Component({
  components: {
    ButtonBase,
    PanelFrame,
  },
})
export default class StudentPersonalProgressPanel extends Vue {
  /** 生徒ニックネーム */
  @Prop()
  private studentName!: string

  /** 生徒学習進捗タブの状態: trueならactive */
  @Prop({ default: false })
  private isStudentProgressTabActive!: boolean

  /** 知識MAPタブの状態: trueならactive */
  @Prop({ default: false })
  private isKnowledgeMapTabActive!: boolean

  /** 生徒学習進捗タブクリック時のイベント */
  @Prop()
  private eventClickStudentProgressTab?: () => void

  /** 知識MAPタブクリック時のイベント */
  @Prop()
  private eventClickKnowledgeMapTab?: () => void

  /**
   * 生徒学習進捗タブクリックイベントのラッパーメソッド(undefined時のエラー回避)
   */
  private clickStudentProgressTab(): void {
    // undefinedブロック
    if (!this.eventClickStudentProgressTab) {
      return
    }
    this.eventClickStudentProgressTab()
  }

  /**
   * 知識MAPタブクリックイベントのラッパーメソッド(undefined時のエラー回避)
   */
  private clickKnowledgeMapTab(): void {
    // undefinedブロック
    if (!this.eventClickKnowledgeMapTab) {
      return
    }
    this.eventClickKnowledgeMapTab()
  }
}
